export default __webpack_public_path__ + "static/media/skovstykket-floorplans-apartment-3-06.41dc33f9.jpg";